import React from 'react';
import { MandateGeneralDto } from '../../../services/dtos/mandate-general.dto';
import { MandateEstablishmentDto } from '../../../services/dtos/mandate-establishment-dto';
import { MandateTerritoryDto } from '../../../services/dtos/mandate-territory.dto';
import DocumentsUi from '../documents/documents.ui';

const MAP_DOCUMENT_TYPE = 'document_carte';

/**
 * Ui de l'onglet cartes.
 * Les cartes sont des documents gouvernance/SIRENE rattachés au territoire ou à l'établissement du mandat.
 */
export default function MapUi(
    props: Readonly<{ mandate: MandateGeneralDto | MandateEstablishmentDto | MandateTerritoryDto }>
) {
    return <DocumentsUi mandate={props.mandate} fixedType={MAP_DOCUMENT_TYPE} title="Cartes" hideTypeFilter={true} />;
}
